import React from 'react';
import { clsx } from 'clsx';

interface FormFieldProps {
  label?: string;
  error?: string;
  description?: string;
  required?: boolean;
  children: React.ReactNode;
  className?: string;
}

export const FormField: React.FC<FormFieldProps> = ({
  label,
  error,
  description,
  required,
  children,
  className,
}) => {
  return (
    <div className={clsx('space-y-1.5', className)}>
      {label && (
        <label className="block text-sm font-medium" style={{ color: 'var(--theme-card-text)' }}>
          {label}
          {required && <span style={{ color: 'var(--theme-error-color)' }} className="ml-1">*</span>}
        </label>
      )}
      {children}
      {description && !error && (
        <p className="text-xs" style={{ color: 'var(--theme-muted-text)' }}>{description}</p>
      )}
      {error && (
        <p className="text-xs" style={{ color: 'var(--theme-error-color)' }}>{error}</p>
      )}
    </div>
  );
};
